/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import { Provider } from '@ethersproject/providers'
import type { RenMintGatewayV3, RenMintGatewayV3Interface } from '../RenMintGatewayV3'

const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'asset',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'selectorHash',
                type: 'bytes32',
            },
        ],
        name: 'LogAssetUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'bytes',
                name: 'to',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'burnNonce',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'bytes',
                name: 'indexedTo',
                type: 'bytes',
            },
        ],
        name: 'LogBurn',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'recipientAddress',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'recipientChain',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'recipientPayload',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'burnNonce',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'string',
                name: 'recipientAddressIndexed',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'string',
                name: 'recipientChainIndexed',
                type: 'string',
            },
        ],
        name: 'LogBurnToChain',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'sigHash',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'nHash',
                type: 'bytes32',
            },
        ],
        name: 'LogMint',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'oldPreviousGateway',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newPreviousGateway',
                type: 'address',
            },
        ],
        name: 'LogPreviousGatewayUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'oldSignatureVerifier',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newSignatureVerifier',
                type: 'address',
            },
        ],
        name: 'LogSignatureVerifierUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
        ],
        name: 'LogTokenUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'tokenAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'nextTokenOwner',
                type: 'address',
            },
        ],
        name: 'TokenOwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [],
        name: 'NAME',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'asset_',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'signatureVerifier_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'token_',
                type: 'address',
            },
        ],
        name: '__GatewayStateManager_init',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'asset_',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'signatureVerifier_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'token_',
                type: 'address',
            },
        ],
        name: '__MintGateway_init',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'recipientAddress',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'recipientChain',
                type: 'string',
            },
            {
                internalType: 'bytes',
                name: 'recipientPayload',
                type: 'bytes',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'caller',
                type: 'address',
            },
        ],
        name: '_burnFromPreviousGateway',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'pHash',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: 'nHash',
                type: 'bytes32',
            },
            {
                internalType: 'bytes',
                name: 'sig',
                type: 'bytes',
            },
            {
                internalType: 'address',
                name: 'caller',
                type: 'address',
            },
        ],
        name: '_mintFromPreviousGateway',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes',
                name: 'recipient',
                type: 'bytes',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'burn',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'recipient',
                type: 'string',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'burn',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'recipientAddress',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'recipientChain',
                type: 'string',
            },
            {
                internalType: 'bytes',
                name: 'recipientPayload',
                type: 'bytes',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'burnWithPayload',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getAsset',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getEventNonce',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getPreviousGateway',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getSelectorHash',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getSignatureVerifier',
        outputs: [
            {
                internalType: 'contract IRenVMSignatureVerifier',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getToken',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'pHash',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: 'nHash',
                type: 'bytes32',
            },
            {
                internalType: 'bytes',
                name: 'sig',
                type: 'bytes',
            },
        ],
        name: 'mint',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'hash',
                type: 'bytes32',
            },
        ],
        name: 'status',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'token',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'nextTokenOwner',
                type: 'address',
            },
        ],
        name: 'transferTokenOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'nextAsset',
                type: 'string',
            },
        ],
        name: 'updateAsset',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newPreviousGateway',
                type: 'address',
            },
        ],
        name: 'updatePreviousGateway',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newSignatureVerifier',
                type: 'address',
            },
        ],
        name: 'updateSignatureVerifier',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newToken',
                type: 'address',
            },
        ],
        name: 'updateToken',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
]

export class RenMintGatewayV3__factory {
    static readonly abi = _abi
    static createInterface(): RenMintGatewayV3Interface {
        return new utils.Interface(_abi) as RenMintGatewayV3Interface
    }
    static connect(address: string, signerOrProvider: Signer | Provider): RenMintGatewayV3 {
        return new Contract(address, _abi, signerOrProvider) as RenMintGatewayV3
    }
}
